export default __webpack_public_path__ + "static/color-application-dark-f2c068f766c32901b23906905d581da6.png";